import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  ProductLocationInventoryPricingNoNestingFragment,
  ProductNoNestingFragment,
  ProductOptionNoNestingFragment,
  SelectedOptionNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  ProductIdResultDeepNestingFragment,
  ProductIdResultFragment,
  StockNumberNotFoundErrorDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import * as Yup from "yup";

export const productFilterInputSchema = Yup.object({
  // term: Yup.string().default(""),
  categories: Yup.array(Yup.string().required()),
  departments: Yup.array(Yup.string().required()),
  limit: Yup.number().integer().positive(),
  page: Yup.number().integer().positive().default(1),
});

const ListProductFieldsFragment = gql`
  fragment ListProductFields on Product {
    id
    name
    taxable
    active
    description
    stockCode
    stockNumber
    variantParentId
    categoryId
    departmentId
    discountable
    internal
    adjustable
    image {
      path
    }
    price
    priceExcludingTax
    loyaltyPointEarnValue
    loyaltyPointRedeemValue
    serialNumbersArr
    serialNumbersSale
    createdAt
    updatedAt
    deletedAt
  }
`;

export const PRODUCT_QUERY = gql`
  ${ProductNoNestingFragment}
  ${ProductLocationInventoryPricingNoNestingFragment}
  ${ProductOptionNoNestingFragment}
  ${SelectedOptionNoNestingFragment}
  query GetProduct($id: ID!) {
    product(id: $id) {
      ...ProductNoNesting
      locationInventoryPricing {
        ...ProductLocationInventoryPricingNoNesting
      }
      options {
        ...ProductOptionNoNesting
      }
      selectedOptions {
        ...SelectedOptionNoNesting
      }
      image {
        path
      }
    }
  }
`;

export const PRODUCT_ID_BY_STOCK_NUMBER_QUERY = gql`
  ${ProductIdResultDeepNestingFragment}
  ${StockNumberNotFoundErrorDeepNestingFragment}
  query GetProductIdByStockNumber($stockNumber: String!) {
    productIdByStockNumber(stockNumber: $stockNumber) {
      ... on ProductIdResult {
        ...ProductIdResultDeepNesting
      }
      ... on StockNumberNotFoundError {
        ...StockNumberNotFoundErrorDeepNesting
      }
    }
  }
`;

export const PRODUCTS_QUERY = gql`
  ${ListProductFieldsFragment}
  ${PaginatedListMetaNoNestingFragment}
  query GetProducts($options: ProductListOptions) {
    products(options: $options) {
      items {
        ...ListProductFields
      }
      meta {
        ...PaginatedListMetaNoNesting
      }
    }
  }
`;
